import React from "react";
import styled from "styled-components";
import moment from "moment";

import { capitalize, currentLanguage } from "helpers";

import Calender from "icons/CalenderIcon";
import Ticket from "icons/TicketIcon";

import MobileEventInfo from "./MobileEventInfo";
import Container from "partials/Container";
import GridElement from "partials/GridElement";
import SmartLink from "partials/SmartLink";
import Button from "partials/Button";
import FavoriteButton from "partials/FavoriteButton";

import Media from "css/Media";

const EventInfo = (props) => {
  const getDate = (date) => {
    return (
      capitalize(moment(date).format("dddd D.")) +
      " " +
      capitalize(moment(date).format("MMM YYYY"))
    );
  };
  const getTime = (date) => {
    return currentLanguage() === "no"
      ? ", kl. " + moment(date).format("H:mm")
      : ", at " + moment(date).format("H:mm");
  };
  const getDateRange = (from, to) => {
    return (
      moment(from).format("D.") +
      " " +
      capitalize(moment(from).format("MMM")) +
      " - " +
      moment(to).format("D.") +
      " " +
      capitalize(moment(to).format("MMM YYYY"))
    );
  };
  const getTravelizeUrl = () => {
    return `https://svalbardadventures.travelize24.com/clientfiles/svalbardbooking.asp?WebSiteUser=ssWeb&productcode=${
      props.data.acf.travelize_id
    }&showpicture=no&showtext=no&lang=${
      currentLanguage() === "no" ? "NO" : "UK"
    }`;
  };

  const { data, isMobile } = props;

  return (
    <Wrapper>
      <Container grid>
        {!isMobile && (
          <StyledGridElement colStart={7} colEnd={20}>
            {data.acf.from_date && !data.acf.end_date && (
              <DateWrapper>
                <Calender />
                <span>
                  {getDate(data.acf.from_date)}
                  {data.acf.display_starting_time
                    ? getTime(data.acf.from_date)
                    : null}
                </span>
              </DateWrapper>
            )}
            {data.acf.from_date && data.acf.end_date && (
              <DateWrapper>
                <Calender />
                <span>
                  {getDateRange(data.acf.from_date, data.acf.end_date)}
                </span>
              </DateWrapper>
            )}
            {data.acf.price && (
              <PriceWrapper>
                <Ticket />
                <span>{"NOK " + data.acf.price}</span>
              </PriceWrapper>
            )}
            {data.acf.e_billett_button_text && data.acf.button_link && (
              <StyledSmartLink to={data.acf.button_link} target='_blank'>
                <StyledButton>{data.acf.e_billett_button_text}</StyledButton>
              </StyledSmartLink>
            )}
            {data.acf.travelize_button_text && data.acf.travelize_id && (
              <StyledSmartLink to={getTravelizeUrl()} target='_blank'>
                <StyledButton>{data.acf.travelize_button_text}</StyledButton>
              </StyledSmartLink>
            )}
            {data.acf.web_page_url && (
              <Contact>
                <a href={data.acf.web_page_url.url} target='_blank'>
                  <span>{data.acf.web_page_url.title}</span>
                </a>
              </Contact>
            )}
            <FavoriteButton item={data} sort={data.type} />
          </StyledGridElement>
        )}
        {isMobile && <MobileEventInfo data={data} />}
      </Container>
    </Wrapper>
  );
};

export default EventInfo;

const Wrapper = styled.div``;

const StyledGridElement = styled(GridElement)`
  display: flex;
  align-items: center;
`;

const StyledButton = styled(Button)`
  width: ${(props) => props.theme.spacing.blockXL};
  padding: ${(props) => props.theme.spacing.contentS};
`;

const StyledSmartLink = styled(SmartLink)`
  ${Media.greaterThan("s")`
        margin-right: ${(props) => props.theme.spacing.elementXS};
    `}
`;

const Contact = styled.div`
  display: flex;
  margin-right: ${(props) => props.theme.spacing.elementM};

  a {
    color: ${(props) => props.theme.colors.link};
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
`;

const DateWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: ${(props) => props.theme.spacing.elementXS};

  svg {
    margin-right: ${(props) => props.theme.spacing.contentM};
    fill: ${(props) => props.theme.colors.text};
  }

  span {
    ${(props) => props.theme.fonts.p};
  }
`;

const PriceWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: ${(props) => props.theme.spacing.elementXS};

  svg {
    margin-right: ${(props) => props.theme.spacing.contentM};
    fill: ${(props) => props.theme.colors.text};
  }

  span {
    ${(props) => props.theme.fonts.p};
  }
`;
